// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2diR8","amount":"Amount_amount__3EMVB","tip":"Amount_tip__1JeS0","tipHeader":"Amount_tipHeader__1_Jaw","tipsWrap":"Amount_tipsWrap__2q_Of"};